<template>
  <div class="IPRelayApp">
    <IprelayHeader :title="sharedState.strings.register" />
    <main class="main--flexed">
      <div class="registerInner">
        <div v-if="sharedState.showProfile"><UserProfile v-model="profile" /></div>
        <div v-else>
          <p class="registration_thanks">
            {{
              sharedState.strings.registration_thanks
                ? sharedState.strings.registration_thanks.replace(/\\n/g, '\n')
                : ''
            }}
          </p>
        </div>
      </div>
    </main>
    <IprelayFooter />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import UserProfile from './UserProfile'
import IprelayFooter from './IprelayFooter'
import IprelayHeader from './IprelayHeader'

export default {
  name: 'Register',
  components: { UserProfile, IprelayFooter, IprelayHeader },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['sharedState']),
  },
  watch: {
    $route(to) {
      if (to.params) {
        this.sharedState.common.setLanguage(this.sharedState, to.params.lang)
      }
    },
  },
  mounted: function () {
    if (this.$route && this.$route.params) {
      this.sharedState.common.setLanguage(this.sharedState, this.$route.params.lang)
    }
  },
  methods: {},
}
</script>
